module.exports = __webpack_public_path__ + "static/media/s_v10_t8_2.2dd52d84.mp3";